/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

function Tabs({ switchContent, currentTab }) {
  return (
    <div className="tabs-container site-container--hug-on-mobile">
      <ul className="section-tabs section-tabs--match">
        <li
          onClick={() => switchContent(0)}
          className={`section-tabs__item ${
            currentTab === 0 ? 'section-tabs__item--active' : ''
          }`}
        >
          INFÖR
        </li>
        <li
          onClick={() => switchContent(1)}
          className={`section-tabs__item ${
            currentTab === 1 ? 'section-tabs__item--active' : ''
          }`}
        >
          <span className="d-none d-lg-inline">MATCHHÄNDELSER</span>
          <span className="d-inline d-lg-none">HÄNDELSER</span>
        </li>
        <li
          onClick={() => switchContent(2)}
          className={`section-tabs__item ${
            currentTab === 2 ? 'section-tabs__item--active' : ''
          }`}
        >
          TRUPPEN
        </li>
        <li
          onClick={() => switchContent(3)}
          className={`section-tabs__item ${
            currentTab === 3 ? 'section-tabs__item--active' : ''
          }`}
        >
          <span className="d-none d-lg-inline">MATCHSTATISTIK</span>
          <span className="d-inline d-lg-none">STATISTIK</span>
        </li>
      </ul>
    </div>
  );
}

export default Tabs;
